import React, { Component } from 'react'
import { Row } from 'reactstrap'
import Bg_1 from '../img/bg_1.png'
import Bg_2 from '../img/bg_2.png'
import Bg_3 from '../img/bg_3.png'
import Bg_4 from '../img/bg_4.png'
import Bg_5 from '../img/bg_5.png'
import Bg_6 from '../img/bg_6.png'
import Bg_7 from '../img/bg_7.png'
import Bg_8 from '../img/bg_8.png'
import Bg_9 from '../img/bg_9.png'
import Bg_10 from '../img/bg_10.png'
import Bg_11 from '../img/bg_11.png'
import Bg_12 from '../img/bg_12.png'
import Bg_13 from '../img/bg_13.png'
import '../App.css'

class ImageSection extends Component {
  render() {
    return (
      <div>
        <Row className="App-ImageSection">
          <img src={Bg_1} className="Bg_Col1" alt="Bg_1" />
          <img src={Bg_2} className="Bg_Col2" alt="Bg_2" />
          <img src={Bg_3} className="Bg_Col3" alt="Bg_3" />
          <img src={Bg_4} className="Bg_Col4" alt="Bg_4" />
          <img src={Bg_5} className="Bg_Col5" alt="Bg_5" />
          <img src={Bg_6} className="Bg_Col6" alt="Bg_6" />
          <img src={Bg_7} className="Bg_Col7" alt="Bg_7" />
          <img src={Bg_8} className="Bg_Col8" alt="Bg_8" />
          <img src={Bg_9} className="Bg_Col9" alt="Bg_9" />
          <img src={Bg_10} className="Bg_Col10" alt="Bg_10" />
          <img src={Bg_11} className="Bg_Col11" alt="Bg_11" />
          <img src={Bg_12} className="Bg_Col12" alt="Bg_12" />
          <img src={Bg_13} className="Bg_Col13" alt="Bg_13" />
        </Row>
        <Row className="App-MobileView-ImageSection">
          <img src={Bg_1} className="Bg_Col1" alt="Bg_1" />
          <img src={Bg_2} className="Bg_Col2" alt="Bg_2" />
          <img src={Bg_3} className="Bg_Col3" alt="Bg_3" />
          <img src={Bg_4} className="Bg_Col4" alt="Bg_4" />
          <img src={Bg_5} className="Bg_Col5" alt="Bg_5" />
          <img src={Bg_6} className="Bg_Col6" alt="Bg_6" />
        </Row>
      </div>
    )
  }
}

export default ImageSection



// WEBPACK FOOTER //
// ./src/components/ImageSection.js